module.exports = __webpack_public_path__ + "static/row-d67756682138408f1386638dfcb4952f.gif";